import { Tabs } from 'bold-ui'
import CheckPermission from 'components/auth/CheckPermission'
import { useSession } from 'components/auth/useSession'
import { Breadcrumb } from 'components/breadcrumb'
import { PageContent } from 'components/layout/PageContent'
import { PageHeaderSection } from 'components/PageHeaderSection'
import { TabLink } from 'components/route'
import { PecSwitch } from 'components/route/PecSwitch'
import { PrivateRoute } from 'components/route/PrivateRoute'
import { useFlags } from 'config/useFlagsContext'
import { Redirect, useRouteMatch } from 'react-router'
import Permissions from 'types/Permissions'

import { ConfiguracoesCertificadosRootView } from './certificados/ConfiguracoesCertificadosRootView'
import { ConfiguracaoAgendaMunicipioRootView } from './configuracao-padrao/ConfiguracaoAgendaMunicipioRootView'
import { GrupoExameRootView } from './grupos-exames/GrupoExameRootView'
import { RndsView } from './rnds/RndsView'
import { VincularEstabelecimentoReferenciaView } from './servicos-referencia/estabelecimento/vincular/VincularEstabelecimentoReferenciaView'
import { SERVICOS_REFERENCIA_PATH, ServicosReferenciaView } from './servicos-referencia/ServicosReferenciaView'
import { TipoServicoView } from './tipo-servico/TipoServicoView'

export function GestaoMunicipalRootView() {
  const match = useRouteMatch()
  const { hasAuthorization } = useSession()
  const {
    ENVIO_RAC_ENABLED,
    PILOTO_RNDS_REPM_ENABLED,
    ENVIO_RPM_ENABLED,
    ENVIO_VACINA_ENABLED,
    PILOTO_VINCULACAO_CUIDADO_ENABLED,
  } = useFlags()

  const rndsEnabled = ENVIO_RAC_ENABLED || PILOTO_RNDS_REPM_ENABLED || ENVIO_RPM_ENABLED || ENVIO_VACINA_ENABLED

  return (
    <>
      <Breadcrumb title='Gestão municipal' />
      <PecSwitch>
        <PrivateRoute
          path={`${match.url}${SERVICOS_REFERENCIA_PATH}/adicionar`}
          component={VincularEstabelecimentoReferenciaView}
          permission={Permissions.configuracaoMunicipal}
        />
        <PrivateRoute
          path={`${match.url}${SERVICOS_REFERENCIA_PATH}/editar/:estabelecimentoReferenciaId(\\d+)`}
          component={VincularEstabelecimentoReferenciaView}
          permission={Permissions.configuracaoMunicipal}
        />

        <PrivateRoute path={match.url} permission={Permissions.configuracaoMunicipal}>
          <PageHeaderSection title='Gestão municipal'>
            <Tabs>
              <CheckPermission permission={Permissions.configuracaoMunicipal.configurarAgendaPadrao}>
                <TabLink to={`${match.url}/cfgagendapadrao`}>Configuração da agenda padrão</TabLink>
              </CheckPermission>
              <CheckPermission permission={Permissions.configuracaoMunicipal.configurarCertificado}>
                <TabLink to={`${match.url}/cfgcertificados`}>Certificados</TabLink>
              </CheckPermission>
              <CheckPermission permission={Permissions.configuracaoMunicipal.cadastrarEditarEExcluirGruposDeExames}>
                <TabLink to={`${match.url}/gpexames`}>Grupos de exames</TabLink>
              </CheckPermission>
              <CheckPermission permission={Permissions.configuracaoMunicipal.cadastrarEditarEExcluirTipoDeServico}>
                <TabLink to={`${match.url}/tpservico`}>Tipos de serviço</TabLink>
              </CheckPermission>
              {rndsEnabled && (
                <CheckPermission permission={Permissions.configuracaoMunicipal.visualizarEnvioRnds}>
                  <TabLink to={`${match.url}/rnds`}>RNDS</TabLink>
                </CheckPermission>
              )}
              {PILOTO_VINCULACAO_CUIDADO_ENABLED && (
                <CheckPermission permission={Permissions.configuracaoMunicipal}>
                  <TabLink to={`${match.url}${SERVICOS_REFERENCIA_PATH}`}>Serviços de referência</TabLink>
                </CheckPermission>
              )}
            </Tabs>
          </PageHeaderSection>
          <PageContent>
            <PecSwitch>
              {hasAuthorization(Permissions.configuracaoMunicipal.configurarAgendaPadrao) && (
                <Redirect exact from={`${match.url}`} to={`${match.url}/cfgagendapadrao`} />
              )}
              {hasAuthorization(Permissions.configuracaoMunicipal.configurarCertificado) && (
                <Redirect exact from={`${match.url}`} to={`${match.url}/cfgcertificados`} />
              )}
              {hasAuthorization(Permissions.configuracaoMunicipal.cadastrarEditarEExcluirGruposDeExames) && (
                <Redirect exact from={`${match.url}`} to={`${match.url}/gpexames`} />
              )}
              {hasAuthorization(Permissions.configuracaoMunicipal.cadastrarEditarEExcluirTipoDeServico) && (
                <Redirect exact from={`${match.url}`} to={`${match.url}/tpservico`} />
              )}
              {hasAuthorization(Permissions.configuracaoMunicipal.visualizarEnvioRnds) && rndsEnabled && (
                <Redirect exact from={`${match.url}`} to={`${match.url}/rnds`} />
              )}
              {hasAuthorization(Permissions.configuracaoMunicipal) && PILOTO_VINCULACAO_CUIDADO_ENABLED && (
                <Redirect exact from={`${match.url}`} to={`${match.url}${SERVICOS_REFERENCIA_PATH}`} />
              )}

              <PrivateRoute
                path={`${match.url}/cfgagendapadrao`}
                component={ConfiguracaoAgendaMunicipioRootView}
                permission={Permissions.configuracaoMunicipal.configurarAgendaPadrao}
              />
              <PrivateRoute
                path={`${match.url}/cfgcertificados`}
                component={ConfiguracoesCertificadosRootView}
                permission={Permissions.configuracaoMunicipal.configurarCertificado}
              />
              <PrivateRoute
                path={`${match.url}/gpexames`}
                component={GrupoExameRootView}
                permission={Permissions.configuracaoMunicipal.cadastrarEditarEExcluirGruposDeExames}
              />
              <PrivateRoute
                path={`${match.url}/tpservico`}
                component={TipoServicoView}
                permission={Permissions.configuracaoMunicipal.cadastrarEditarEExcluirTipoDeServico}
              />
              <PrivateRoute
                path={`${match.url}/rnds`}
                component={RndsView}
                permission={rndsEnabled ? Permissions.configuracaoMunicipal.visualizarEnvioRnds : undefined}
              />
              <PrivateRoute
                path={`${match.url}${SERVICOS_REFERENCIA_PATH}`}
                component={ServicosReferenciaView}
                permission={PILOTO_VINCULACAO_CUIDADO_ENABLED && Permissions.configuracaoMunicipal}
              />
            </PecSwitch>
          </PageContent>
        </PrivateRoute>
      </PecSwitch>
    </>
  )
}
